import { getBasePath } from "@/config/basePath";

const basePath = getBasePath();

/**
 * Internal Next.js API routes (route.ts handlers).
 *
 * Almost all auth flows now use server actions. The only routes that remain
 * are the ones that need a stable, browser-addressable URL:
 *   - HEALTH:  Docker / load-balancer healthcheck
 *   - LOGOUT:  GET-only redirect endpoint for 401 fallbacks and `<a>` links
 */
export const NEXT_API_ROUTES = {
  HEALTH: `${basePath}/api/health`,
  LOGOUT: `${basePath}/api/auth/logout`,
  // AI-gateway WebSocket proxy — streaming POST per turn (see
  // app/api/ai-gateway/turn/route.ts). Browser-addressable because the chat
  // hook streams its NDJSON response.
  AI_GATEWAY_TURN: `${basePath}/api/ai-gateway/turn`,
} as const;

export const LOGOUT_ENDPOINT_INSIDE = NEXT_API_ROUTES.LOGOUT;
export const HEALTH_ENDPOINT_INSIDE = NEXT_API_ROUTES.HEALTH;
export const AI_GATEWAY_TURN_ENDPOINT_INSIDE = NEXT_API_ROUTES.AI_GATEWAY_TURN;
